import React from 'react';
import PropTypes from 'prop-types';

import ListView from '../Common/ListView.react';
import ListItem from '../User/UserListItem';
import FlatButton from 'material-ui/FlatButton';
import LinearProgress from 'material-ui/LinearProgress';

import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import UpIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-up';
import DownIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-down';

import UserGroupStore from '../../stores/UserGroupStore';
import UserGroupMemberStore from '../../stores/UserGroupMemberStore';
import UserGroupActions from '../../actions/UserGroupActionCreator';

import ROLES from '../../constants/Roles';
import buildContextMenu from '../Common/BuildContextMenu';

const UserGroup = React.createClass({

    getInitialState: function () {
        return {
            details: {
                id: '',
                name: '',
                description: '',
                sysStatus: 0,
            },
            limit: 50,
            page: 0,
            loading: false,
            fetchedAll: false,
            showButton: false,
            members: [],
            actions: [],
            menuItems: [
                {
                    link: '/dashboard/usergroup/' + this.props.routeParams.id + '/edit',
                    icon: <EditIcon />,
                    label: 'Edit',
                    condition: {
                        roles: [ROLES.ADMIN]
                    }
                },
                {
                    type: 'deleteDialog',
                    dialogType: 'menu',
                    value: this.props.routeParams.id,
                    title: 'Delete ',
                    deleteAction: this.onDelete,
                    message: (
                                <span>
                                    Are you sure you want to delete this user group?
                                </span>
                            ),
                    condition: {
                        roles: [ROLES.ADMIN]
                    }
                }
            ],
            links: {
                back: '/dashboard/usergroups',
                edit: '',

            }
        }
    },

    componentDidMount: function() {
        UserGroupStore.addChangeListener(this.onChange);
        UserGroupActions.getById(this.props.routeParams.id);
        UserGroupActions.getMembers(this.props.routeParams.id, {limit: this.state.limit});
        this.membersListener = UserGroupMemberStore.addListener(this.onMemberChange);

        window.addEventListener('scroll', this.handleScroll);

        this.setState({actions: buildContextMenu(this.state.menuItems, this.context.auth)});
    },

    componentWillUnmount: function() {
        UserGroupStore.removeChangeListener(this.onChange);
        this.membersListener.remove();

        window.removeEventListener('scroll', this.handleScroll);
    },

    render: function () {

        return(
            <div ref="userGroupMembers" >
                <ListView
                    title={this.state.details.name}
                    items={this.state.members}
                    itemDecorator={ListItem}
                    actions={this.state.actions}
                />
                {this.state.loading && (
                    <LinearProgress mode="indeterminate" />
                )}
                {this.state.showButton && (
                    <FlatButton
                        label={this.state.fetchedAll ? 'Back to top' : 'Load more'}
                        icon={this.state.fetchedAll ? <UpIcon/> : <DownIcon/>}
                        onTouchTap={this.state.fetchedAll ? () => window.scrollTo(0, 0) : this.loadNextPage}
                        disabled={this.state.loading}
                        fullWidth
                    />
                )}
            </div>
        );
    },

    onChange: function() {
        const details = UserGroupStore.getById(this.props.routeParams.id);
        if (details !== undefined) {
            this.setState({details: details});
        }
    },

    onMemberChange: function() {
        const members = UserGroupMemberStore.getMembers(this.props.routeParams.id);
        if (members !== undefined) {
            this.setState({members, loading: false, fetchedAll: UserGroupMemberStore.fetchedAll()});
        }
    },

    onDelete: function(entityId) {
        if (entityId == this.props.routeParams.id) {
            UserGroupActions.delete(entityId);
            window.location.href = this.state.links.back;
        }
    },

    loadNextPage: function() {
        if (this.state.loading) { return; } //guard

        const page = (this.state.page + 1);
        UserGroupActions.getMembers(this.props.routeParams.id, {page, limit: this.state.limit}, false);
        this.setState({page, loading: true});
    },

    handleScroll: function() {
        if (!this.state.showButton) {
            this.setState({showButton: true});
        }
        if (!this.state.fetchedAll && (window.scrollY + window.innerHeight) >= this.refs.userGroupMembers.clientHeight) {
            this.loadNextPage();
        }
    }

});

UserGroup.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default UserGroup;
